import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import ErrorBoundary from './ErrorBoundary';

export default function FunnelLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background selection:bg-accent/30 selection:text-accent relative">
      <div className="noise" />
      
      {/* Minimal Header */}
      <header className="fixed top-0 left-0 w-full z-50 py-6 px-8 flex justify-center md:justify-start">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-10 h-10 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center text-accent group-hover:scale-110 transition-transform duration-500">
            <Shield className="w-6 h-6" />
          </div>
          <span className="text-xl font-display font-bold tracking-tighter">AGRAND<span className="text-accent">INTL</span></span>
        </Link>
      </header>

      <main className="flex-grow">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      {/* Minimal Footer */}
      <footer className="py-12 px-8 border-t border-white/5 text-center">
        <p className="text-xs text-muted-foreground font-light tracking-widest uppercase">
          © {new Date().getFullYear()} AGRANDINTL. All Rights Reserved. Secure by Design.
        </p>
      </footer>
    </div>
  );
}
